import { CountryAttributes } from "./country-attributes";
import { BusinessAttributes } from "./business-attributes";
import { BusinessBranchAttributes } from "./business-branch-attributes";
import { ConnectionLogAttributes } from "./connection-log-attributes";
import { DocumentAttributes } from "./document-attributes";
import { AccountAttributes } from "./account-attributes";
import { BranchManagerAttributes } from "./branch-manager-attributes";
import {AdminRoleAttributes} from "./admin-role-attributes";
import {LanguageAttributes} from "./language-attributes";

export interface SendOtpRequestAttributes {
  telephone: string;
  country_iso_code: string;
}

export interface CheckOtpRequestAttributes {
  telephone: string;
  otp: string;
}

export enum IdentificationTypeIdEnum {
  cni = "cni",
  passport = "passport",
}

export const IdentificationTypeTranslations = {
  [IdentificationTypeIdEnum.cni]: "sharedScreen.nationalIdentityCard",
  [IdentificationTypeIdEnum.passport]: "sharedScreen.passport",
};

export interface CheckPinRequestAttributes {
  phone_number: string;
  pin_code: string;
  device_name: null;
  device_model: null;
}

export interface AdminLoginRequestAttributes {
  username: string;
  password: string;
  device_name: null;
  device_model: null;
}

export interface SignupRequestAttributes {
  country_iso_code: string;
  email: string;
  telephone: string;
  secondary_telephone: string;
  pin_code: string;
  last_name: string;
  first_name: string;
  profile_picture: string | null;
  data_of_birth: string;
  birth_place: string;
  address: string;
  city: string | null;
}

export interface SignupCniRequestAttributes {
  id_number: string;
  identification_type_id: IdentificationTypeIdEnum;
  cni_back: string | null;
  cni_front: string | null;
  expiration_date: string;
  issue_date: string;
}

export interface SignupPassportRequestAttributes {
  id_number: string;
  identification_type_id: IdentificationTypeIdEnum;
  passport: string | null;
  expiration_date: string;
  issue_date: string;
}

export interface UserAttributes {
  id: number;
  login: string;
  user_account_type: number;
  pin_attempts_left: number;
  profile_picture: string | null;
  avatar: string | null;
  blocked_at: string | null;
  declined_at: string | null;
  requested_more_at: string | null;
  validation_date: string | null;
  created_at: string | null;
  currency_code: string;
  message: string;
  user_detail?: UserDetailsAttributes;
  country?: CountryAttributes;
  businesses?: Array<BusinessAttributes>;
  branches?: Array<BusinessBranchAttributes>;
  connection_log?: ConnectionLogAttributes;
  documents?: Array<DocumentAttributes>;
  accounts?: Array<AccountAttributes>;
  branch_managers?: Array<BranchManagerAttributes>;
  admin_roles?: Array<AdminRoleAttributes>;
  language?: LanguageAttributes;
}

export interface UserDetailsAttributes {
  id: number;
  telephone: string;
  activity_time_preference: string;
  identification_type_id: IdentificationTypeIdEnum;
  last_name: string;
  first_name: string;
  email: string;
  data_of_birth: string | null;
  birth_place: string | null;
  secondary_telephone: string | null;
  address: string | null;
  city: string | null;
}
